export default __webpack_public_path__ + "static/media/hackillinois_logo.233a4a95.svg";